import React from 'react';
import { useTranslation } from 'react-i18next';

const OrderDetailsModal = ({ isOpen, onClose, orderDetails, loading }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
      {/* Backdrop */}
      <div 
        className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="tw-relative tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-2xl tw-w-full tw-mx-4 tw-z-10">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <h3 className="tw-text-xl tw-font-semibold">
            {t('orders.order_details', 'Order Details')} 
            {orderDetails && <span className="tw-ml-2">#{orderDetails.reference || orderDetails.id}</span>}
          </h3>
          <button 
            onClick={onClose}
            className="tw-text-gray-500 hover:tw-text-gray-700 tw-text-2xl"
          >
            &times;
          </button>
        </div>
        
        <div className="tw-mb-6">
          {loading ? (
            <div className="tw-py-8 tw-text-center">
              <div className="spinner-border text-main-600" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : orderDetails && orderDetails.products && orderDetails.products.length > 0 ? (
            <div className='tw-mb-6 tw-overflow-auto' style={{ maxHeight: "60vh" }}>
              <h4 className="tw-text-lg tw-font-medium tw-mb-3">
                {t('orders.products', 'Products')}
              </h4>
              <table className="tw-w-full tw-border-collapse">
                <thead className="tw-bg-gray-50">
                  <tr>
                    <th className="tw-px-4 tw-py-2 tw-text-left tw-font-medium tw-text-gray-700">
                      {t('orders.product_name', 'Product Name')}
                    </th>
                    <th className="tw-px-4 tw-py-2 tw-text-center tw-font-medium tw-text-gray-700">
                      {t('orders.quantity', 'Quantity')}
                    </th>
                    <th className="tw-px-4 tw-py-2 tw-text-right tw-font-medium tw-text-gray-700">
                      {t('orders.price', 'Price')}
                    </th>
                  </tr>
                </thead>
                <tbody className="tw-divide-y tw-divide-gray-200">
                  {orderDetails.products.map((product, index) => (
                    <tr key={index} className="tw-border-t tw-border-gray-200">
                      <td className="tw-px-4 tw-py-3 tw-text-gray-800">
                        {product.name}
                      </td>
                      <td className="tw-px-4 tw-py-3 tw-text-center tw-text-gray-800">
                        {product.quantity}
                      </td>
                      <td className="tw-px-4 tw-py-3 tw-text-right tw-text-gray-800">
                        {product.calculatedPriceFormatted}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="tw-text-center tw-text-gray-500">{t('orders.no_products', 'No products found for this order.')}</p>
          )}
          
          {/* Shipment Data Section */}
          {!loading && orderDetails && orderDetails.shipmentData && (
            <div className="tw-mt-6 tw-border-t tw-border-gray-200 tw-pt-4">
              <h4 className="tw-text-lg tw-font-medium tw-mb-3">
                {t('orders.shipment_info', 'Shipment Information')}
              </h4>
              <div className="tw-bg-gray-50 tw-rounded-lg tw-p-4">
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <p className="tw-text-sm tw-text-gray-500 tw-mb-1">
                      {t('orders.shipment_label', 'Shipment')}
                    </p>
                    <p className="tw-font-medium">{orderDetails.shipmentData.label}</p>
                  </div>
                  <div>
                    <p className="tw-text-sm tw-text-gray-500 tw-mb-1">
                      {t('orders.shipment_cost', 'Shipment Cost')}
                    </p>
                    <p className="tw-font-medium">{orderDetails.shipmentData.amountFormatted}</p>
                  </div>
                </div>
                
                <div className="tw-mt-3">
                  <p className="tw-text-sm tw-text-gray-500 tw-mb-1">
                    {t('orders.shipping_address', 'Shipping Address')}
                  </p>
                  <p className="tw-font-medium">{orderDetails.shipmentData.address}</p>
                </div>
              </div>
            </div>
          )}
        </div>
        
        <div className="tw-mt-6 tw-flex tw-justify-end">
          <button
            onClick={onClose}
            className="px-16 py-8 btn btn-main rounded-8"
          >
            {t('common.close', 'Close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal; 